import React, { FC, MouseEventHandler } from 'react';
import { useIntl, defineMessages } from 'react-intl';
import { trackEvent } from 'dibs-tracking';
import CartIcon from 'dibs-icons/exports/Cart';

import styles from './CartNav-style.scss';

const MAX_CART_COUNT_DISPLAY = 9;

function handleOnClick(): void {
    trackEvent({
        category: 'navigation',
        action: 'header navigation click',
        label: 'cart|cart header link',
    });
}

const CartNavCount: FC<{ count: number }> = ({ count }) => (
    <div className={styles.countWrapper}>
        <span className={styles.count}>
            {count}
            {count === MAX_CART_COUNT_DISPLAY ? <sup>+</sup> : null}
        </span>
    </div>
);
const messages = defineMessages({
    label: { id: 'dbl.Header.CartNavDropdownTrigger.label', defaultMessage: 'Cart' },
});
const CartNavDropdownTrigger: FC<{ count: number; handleMouseEnter?: MouseEventHandler }> = ({
    count = 0,
    handleMouseEnter = () => {},
}) => {
    count = Math.min(count, MAX_CART_COUNT_DISPLAY);
    const intl = useIntl();
    return (
        <div
            data-tn="cart-nav-dropdown-trigger"
            className={styles.iconWrapper}
            onMouseEnter={handleMouseEnter}
        >
            <a
                className={styles.icon}
                href="/my/cart/"
                aria-label={intl.formatMessage(messages.label)}
                onClick={handleOnClick}
            >
                {count ? <CartNavCount count={count} /> : null}
                <CartIcon />
            </a>
        </div>
    );
};

export default CartNavDropdownTrigger;
